import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import Logo from "../components/Logo";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { IMAGES } from "../lib/images";

export default function Login() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) navigate("/programa");
  }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.toLowerCase().trim(), password);
      toast.success("¡Bienvenida de nuevo!");
      navigate("/programa");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-cream">
      <div className="hidden lg:block relative">
        <img src={IMAGES.hero} alt="Yoga facial" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-forest/30" />
        <div className="absolute bottom-10 left-10 right-10">
          <p className="font-serif text-4xl text-cream leading-tight">“Unos minutos al día para un rostro más luminoso.”</p>
        </div>
      </div>
      <div className="flex flex-col">
        <div className="px-5 sm:px-8 py-6">
          <Link to="/"><Logo /></Link>
        </div>
        <div className="flex-1 flex items-center justify-center px-5 pb-16">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-sm">
            <h1 className="font-serif text-4xl">Accede a tu programa</h1>
            <p className="mt-2 text-forest/60">Inicia sesión para continuar tu ritual.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <div>
                <label className="text-xs tracking-[0.2em] uppercase font-semibold text-forest/60">Email</label>
                <input data-testid="login-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required placeholder="tu@email.com" className="mt-2 w-full rounded-full bg-sage/60 border border-transparent focus:border-clay focus:bg-white outline-none px-5 py-3.5 transition-colors" />
              </div>
              <div>
                <label className="text-xs tracking-[0.2em] uppercase font-semibold text-forest/60">Contraseña</label>
                <input data-testid="login-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required placeholder="••••••••" className="mt-2 w-full rounded-full bg-sage/60 border border-transparent focus:border-clay focus:bg-white outline-none px-5 py-3.5 transition-colors" />
              </div>
              <button data-testid="login-submit-button" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-clay text-cream font-medium px-6 py-4 hover:bg-clay-dark transition-colors disabled:opacity-60">
                {loading ? "Entrando…" : "Entrar"} <ArrowRight className="w-4 h-4" />
              </button>
            </form>
            <p className="mt-6 text-sm text-forest/60 text-center">
              ¿Aún no tienes acceso?{" "}
              <Link to="/" data-testid="go-buy-link" className="text-clay font-medium hover:underline">Empieza por 47€</Link>
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
}
